import { TOUR_STORAGE_PREFIX, type TourId } from './tourIds'

export function isTourComplete(tourId: TourId): boolean {
  try {
    return localStorage.getItem(`${TOUR_STORAGE_PREFIX}${tourId}`) === '1'
  } catch {
    return false
  }
}

export function markTourComplete(tourId: TourId): void {
  try {
    localStorage.setItem(`${TOUR_STORAGE_PREFIX}${tourId}`, '1')
  } catch {
    /* ignore */
  }
}

export function clearTourComplete(tourId: TourId): void {
  try {
    localStorage.removeItem(`${TOUR_STORAGE_PREFIX}${tourId}`)
  } catch {
    /* ignore */
  }
}
